// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8a115f10","488":"2bbfe892","977":"f5f9739f"}[chunkId] + ".chunk.js";
};